import { pipe } from 'fp-ts/function';
import { array, option } from 'fp-ts';
import { AgeCategory, ServiceResult, useRepositoryQuery } from '@mews-commander/data-access';
import { WithServiceId } from '@mews-commander/types';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { sortAgeCategories } from '@mews-commander/legacy-entities/src/ducks/ageCategories';

const extent = {
    ageCategories: true,
    bookingEngines: false,
    businessSegments: false,
    productCategories: false,
    products: false,
    registrationCardConfigurations: false,
    vouchers: false,
};

const select = (data: ServiceResult) =>
    pipe(
        data.ageCategories,
        option.fromNullable,
        option.flatMap(option.fromPredicate(array.isNonEmpty)),
        option.map(sortAgeCategories),
        option.getOrElse<Array<AgeCategory>>(() => [])
    );

export const useServiceAgeCategories = ({ serviceId }: WithServiceId) => {
    const currentEnterpriseId = useCurrentEnterpriseId();

    const { data: ageCategories, isFetching } = useRepositoryQuery(
        'services',
        'getAll',
        {
            enterpriseIds: [currentEnterpriseId],
            serviceIds: [serviceId],
            extent,
        },
        { select }
    );

    return { ageCategories, isFetching };
};
